console.log('massage-addons.js loaded');

async function addAromatherapyToCart() {
  const addonCheckbox = document.querySelector('#aromatherapy-addon');

  if (!addonCheckbox || !addonCheckbox.checked) return;

  const addonVariantId = addonCheckbox.dataset.variantId;

  if (!addonVariantId) {
    alert('Missing aromatherapy variant ID');
    return;
  }

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      items: [
        {
          id: Number(addonVariantId),
          quantity: 1
        }
      ]
    })
  });
}

document.addEventListener(
  'click',
  async function (event) {
    const button = event.target.closest('button[type="submit"], [name="add"]');

    if (!button) return;

    const form = button.closest('form');

    if (!form || !form.action.includes('/cart/add')) return;

    await addAromatherapyToCart();
  },
  true
);